export const CLAIM_RESOLUTION_OPTIONS_CONFIG_KEY = 'claim_resolution_options';
export const CLAIM_RESOLUTION_UNSPECIFIED_FILTER_VALUE = '__UNSPECIFIED__';
export const CLAIM_RESOLUTION_MAX_LENGTH = 30;
export const DEFAULT_CLAIM_RESOLUTION_OPTIONS = ['Approved', 'Denied', 'Paid'] as const;

export interface RetrieveClaimResolutionOptionsResponse extends Record<string, unknown> {
  values: string[];
}

export interface UpdateClaimResolutionOptionsRequest {
  values: string[];
}

export interface UpdateClaimResolutionOptionsResponse {
  values: string[];
}

export function normalizeClaimResolutionValue(value?: string | null): string | null {
  if (typeof value !== 'string') return null;

  const normalized = value.trim();
  return normalized.length ? normalized : null;
}

export function normalizeClaimResolutionOptions(values?: ReadonlyArray<string | null | undefined> | null): string[] {
  const normalizedValues = new Set<string>();

  for (const value of values ?? []) {
    const normalized = normalizeClaimResolutionValue(value);
    if (!normalized) continue;
    if (normalized.length > CLAIM_RESOLUTION_MAX_LENGTH) continue;

    normalizedValues.add(normalized);
  }

  return [...normalizedValues];
}

export function getClaimResolutionOptions(config?: RetrieveClaimResolutionOptionsResponse | null): string[] {
  if (!config) return [];

  return normalizeClaimResolutionOptions(config.values);
}
